<template>
  <div>
    <!-- <a class="Back-Container">
      <simple-header :label="$t('global.back')" @click="$router.back()" />
    </a> -->

    
    <general-informations class="vv-box" />

    <addresses class="vv-box" v-if="remoteConfig.getBoolean('account_delivery_info')" />

    <language class="vv-box" v-if="isVinovibes" />

    <!-- <payment-informations class="vv-box" v-if="remoteConfig.getBoolean('account_bank_info')" /> -->

    <div class="disclaimer">
      {{ $t('userAccount.disclaimer') }}
    </div>
  </div>
</template>

<script>
import Addresses from '@/components/userAccount/personnalInformation/Addresses'
import Language from '@/components/userAccount/personnalInformation/Language'
import GeneralInformations from '@/components/userAccount/personnalInformation/GeneralInformations'
// import PaymentInformations from '@/components/userAccount/personnalInformation/PaymentInformations'
// import SimpleHeader from '../../components/navigation/SimpleHeader'

import remoteConfig from '@/mixins/remoteConfig'

export default {
  name: 'MyAccountHome',
  mixins: [remoteConfig],
  components: {
    Addresses,
    GeneralInformations,
    Language
  },
  computed: {
    isVinovibes() {
      return process.env.VUE_APP_APP_NAME === 'vinovibes'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.disclaimer {
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: $font-color;
  text-align: left;
}



.vv-box {
  margin-bottom: 20px;
}
</style>
